import {updateUserConfiguration} from "@/store/RequestApis/UserConfigurationApi";


const actions = {
    updateUserConfiguration(params) {
        return new Promise((resolve, reject) => {
            updateUserConfiguration(params).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
}

export default actions